import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=8a3845c0"
import script from "./FormEditor.vue?vue&type=script&lang=js"
export * from "./FormEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports